import type { BackupHealth } from '@k-management/shared';
import { Link } from 'react-router';
import { formatTimestamp } from '../lib/format.js';

const MESSAGES: Record<BackupHealth['state'], string> = {
  ok: 'Backup regolari',
  failed: 'L’ultimo backup non è riuscito',
  late: 'Nessun backup riuscito nelle ultime 26 ore',
  never: 'Nessun backup riuscito finora',
};

/** Status of the database backups (docs/adr/ADR-006), in words. */
export function BackupHealthNotice({
  health,
  link = false,
}: {
  health: BackupHealth;
  link?: boolean;
}) {
  const ok = health.state === 'ok';
  return (
    <div
      className={ok ? 'notice ok-notice' : 'notice error-notice'}
      role={ok ? undefined : 'alert'}
    >
      <strong>{MESSAGES[health.state]}</strong>
      {health.lastSuccessAt && (
        <span> · ultimo riuscito il {formatTimestamp(health.lastSuccessAt)}</span>
      )}
      {health.lastError && <span className="details"> · errore: {health.lastError}</span>}
      {link && (
        <>
          {' '}
          <Link to="/admin/backup">Dettagli</Link>
        </>
      )}
    </div>
  );
}
